<template>
    <div class="sfbz">
        <div class="searchall">
            <div class="search" style="margin-top:10px">
                <span>法规标题：</span>
                <input type="text" v-model="ss" style="width:70%" placeholder="请输入法规名称">
                <button class="searchbt" style="margin-left:20px" @click="search">搜索</button>
            </div>
            
            <div class="btns">
                
            </div>
            
        </div>
        
        <div class="sfbzcontent">
            <div class="bz">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<div class="fyitem" v-for="(item, fyindex) in list" :key="fyindex">
                    <div class="fyxx" @click="goxq(item.id)">
                        <span>法规标题：{{ item.title}}</span>
                        <!-- <span>积分：{{ item.nowScore}}</span> -->
                        <span>印发单位：{{ item.issuingUnit}}</span>
                        <span>印发时间：{{item.issuingTime}}</span>
                    </div>
                </div>
			</van-list>
            </div>
        </div>
        <div style="height:20px;width:100%"></div>
    </div>
</template>
<script>
import { ImagePreview } from 'vant';
export default {
    data() {
        return {
            pageNum:0,
            loading: false,//列表加载的
            finished: false,//列表加载的
            refreshing: false,//列表加载的
            refreshing:false,
            ss:'',
            list:[],
            total:'',
            starttime:'',
            endtime:''
        }
    },
    mounted() {
        
    },
    methods: {
        chongzhi(){
            this.starttime = ''
            this.endtime = ''
            this.ss = ''
            this.list = []
            this.pageNum = 0
            this.onLoad()
        },
        goxq(id){
            this.$router.push({path:'/flfg/xq',query:{id:id}})
        },
        search(){
            this.list = []
            this.pageNum = 0
            this.onLoad()
        },
        showimg(index){
            var that = this
            ImagePreview({
                images: that.list[index].attachs.map(item=>{
                    return item.webUrl
                }),
                closeable: true,
            });
        },
        getdata(ss){
            this.$axios.get('/api/v1/wygl/regulations/viewList', {
                params: {
                    pageNum:this.pageNum,
                    pageSize:10,
                    title:ss,
                    orderByColumn: 'issuingTime',
                    isAsc: 'DESC'
                }
            }).then(res => {
                console.log(res)
                this.list = res.data
                this.toatl = res.total
            });
        },
        onLoad(){
            setTimeout(() => {
                if (this.refreshing) {
                    // 清空列表数据
                    this.pageNum = 1;
                    this.list = [];
                    this.refreshing = false;
                }
                this.getdata(this.ss)
                this.pageNum++;
                this.loading = false;
                if (this.list.length >= this.total) {
                    this.finished = true;
                }
            }, 500);
        }
    },
}
</script>
<style lang="less" scoped>
    .sfbz{
        .sfbzcontent{
            margin: 2% 5%;
        }
        .van-list{
            width: 100%;
        }
        .van-swipe-item{
            img{
            height: 100%;
            width: 100%;
            }
        }
        .searchall{
            width: 100%;
            padding: 10px;
            display: flex;
            flex-direction: column;
            input{
                outline: none;
                border: 1px solid #939393;
                border-radius: 5px;
                height: 30px;
            }
        }
        .btns{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
        }
        .searchbt{
            height: 30px;
            width: 100px;
            background: #00b5ff;
            border-radius: 10px;
            border: none;
            outline: none;
            color: #fff;
        }
        .search{
            display: flex;
            align-items: center;
            font-size: 13px;
            text-align: center;
            span{
                width: 30%;
            }
        }
        .datesearch{
            input{
                width: 34%;
            }
        }
        .bz{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            border-radius: 10px;
            box-shadow: 0 0 10px #dadada;
            padding: 0 10px;
            box-sizing: border-box;
            .fyitem {
                margin-top: 10px;
                height: 80px;
                width: 100%;
                display: flex;
                border-bottom: 1px dashed #939393;
                .lb {
                    width: 35%;
                    height: 100%;
                }
                .fyxx {
                    margin-left: 2%;
                    font-size: 13px;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    span:not(:nth-child(1)){
                        margin-top: 5px;
                    }
                }
            }
        }
    }
</style>